import { ReactComponent as VerifySVG } from "../../../assets/vectors/verify.svg";
import { ReactComponent as ErrorSVG } from "../../../assets/vectors/error.svg";
import { ReactComponent as LinearSVG } from "../../../assets/vectors/linear.svg";
import { ReactComponent as EditSVG } from "../../../assets/vectors/edit.svg";

import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { deleteProperty, getPropertyList } from "../../../api/wordpress";

import PageLoader from "../../../components/loaders/page-loader.component";
import GenericModal from "../../../components/modals/generic-modal.component";
import NoRequestsScreen from "./no-requests.screen";
import PublishPropertyForm from "../../../components/forms/publish-property/publish-property-form.component";
import MyPropertyCardLoop from "../../../components/loops/property-card-loop/my-property-card-loop.component";

import { isArray } from "../../../utils/functions";
import { IoCopyOutline } from "react-icons/io5";
import SocialIcons from "../../../components/icon-lists/social-icon-list/social-icon-list.component";
import copy from "copy-to-clipboard";
import RegularButton from "../../../components/buttons/regular-button/regular-button.component";
import { toast } from "sonner";

const PropertyListScreen = () => {
  const [propertyList, setPropertyList] = useState([]);
  const [countPostObj, setCountPostObj] = useState({
    all: 0,
    occupied: 0,
    unOccupied: 0,
  });
  const [loader, setLoader] = useState(true);
  const [dialogLoader, setDialogLoader] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const [errorDialog, setErrorDialog] = useState(false);
  const [shareDialog, setShareDialog] = useState(false);
  const [copiedAlert, setCopiedAlert] = useState(false);
  const [workingSlug, setWorkingSlug] = useState("");
  const [reloadPosts, setReloadPosts] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const email = JSON.parse(localStorage.getItem("user"))?.user?.user_email;
  
  const [params, setParams] = useSearchParams();
  const location = useLocation();

  const closeAllDialog = () => {
    setConfirmDialog(false);
    setDialogLoader(false);
    setErrorDialog(false);
    setShareDialog(false);
    setSuccessDialog(false);
    setCopiedAlert(false);
    setDialogData(null);
    params.delete("id");
    params.delete("action");
    setParams(params);
  };

  const handleDelete = async () => {
    setDialogLoader(true);

    try {
      await deleteProperty(token, workingSlug);
      closeAllDialog();
      setDialogData({
        title: "Success",
        subtitle: "Your Property has been successfully deleted!",
        svgComp: <VerifySVG />,
      });
      setSuccessDialog(true);
      setReloadPosts(true);
    } catch (error) {
      closeAllDialog();
      setDialogData({
        title: "An Error Occured!",
        subtitle: "There was an error deleting your property, please try again.",
        svgComp: <ErrorSVG className="h-[70px]" />,
      });
      setErrorDialog(true);
    }
  };

  useEffect(() => {
    if (params.get("action") !== "delete" && params.get("action") !== "share") {
      setLoader(true);
      const propertyListRequest = async () => {
        let arr = [];
        const response = await getPropertyList(token, { author: email });
        if (!isArray(response.data)) {
          if (Number.isInteger(Number(Object.keys(response.data)[0]))) {
            arr = Object.keys(response.data).map((key) => {
              return response.data[key];
            });
          } else {
            arr[0] = response.data;
          }
        } else {
          arr = response.data;
        }
        setPropertyList(arr);
        setCountPostObj({
          ...countPostObj,
          all: response.headers["x-wp-total"],
          occupied: arr.filter((item) => item.acf.occupancy_status === true).length,
          unOccupied: arr.filter((item) => !item.acf.occupancy_status || item.acf.occupancy_status === false).length,
        });
        setLoader(false);
        setReloadPosts(false);
      };

      propertyListRequest().catch((error) => {
        console.error(error);
        setLoader(false);
      });
    }
  }, [reloadPosts]);

  useEffect(() => {
    if (params.get("action") === "delete") {
      const targetProperty = propertyList.find((property) => String(property.id) === params.get("id"));
      
      if (targetProperty?.status === "pending") {
        toast.error("You cannot delete a property while it is under review.");
        closeAllDialog();
        return;
      }

      if (targetProperty?.acf?.occupancy_status === true ) {
        toast.error("You cannot delete an occupied property. Please mark it as unoccupied before deleting.");
        closeAllDialog();
        return;
      }
      
      setWorkingSlug(params.get("id"));
      setDialogData({
        title: "Are you sure you want to delete this property?",
        subtitle: "Note that this action is irreversible. So if you are sure about this, click confirm to proceed with delete.",
        svgComp: "",
      });
      setConfirmDialog(true);
    } else if (params.get("action") === "edit") {
      const targetProperty = propertyList.find((property) => String(property.id) === params.get("id"));
      
      if (targetProperty?.status === "pending") {
        toast.error("You cannot edit a property while it is under review.");
        closeAllDialog();
        return;
      }
      if (targetProperty?.acf?.occupancy_status === true ) {
        toast.error("You cannot edit an occupied property. Please mark it as unoccupied before editing.");
        closeAllDialog();
        return;
      }
      

      setLoader(false);
    } else if (params.get("action") === "share") {
      let slug = params.get("id");
      if (slug) {
        setWorkingSlug(slug);
        setShareDialog(true);
      }
    } else if (params.get("action") === "copy") {
      let slug = params.get("id");
      if (slug) {
        setDialogData({
          title: "Payment Link Copied!",
          subtitle: "This payment link is now copied to your clipboard, you can paste your payment link to ruumies on your chat.",
          svgComp: <VerifySVG />,
        });
        setCopiedAlert(true);
        navigator.clipboard.writeText(
          "https://app.ruumies.site/checkout?paymentID=" + slug
        );
      }
    }
  }, [params, propertyList]);

  return (
    <>
      {loader ? (
        <PageLoader size="150px" className="p-10 w-full flex justify-center" />
      ) : propertyList.length === 0 && params.get("action") !== "edit" ? (
        <NoRequestsScreen />
      ) : params.get("action") === "edit" ? (
        <PublishPropertyForm
          setReloadPosts={setReloadPosts}
          setParams={setParams}
        />
      ) : (
        <div className="max-w-full overflow-x-hidden">
           <div className="md:hidden mb-2 w-fit justify-self-end">
            <RegularButton
              exticon={<EditSVG className="pr-2 svg-icon-white " />}
              linkTo="/dashboard/my-properties?action=add-new"
              text="Upload property"
            />
          </div>
          <div className="grid grid-cols-3 gap-3 md:gap-5">
            <button className="border border-gray-300 hover:border-secondary rounded-md flex flex-col md:flex-row gap-3 md:gap-6 items-center py-3 md:p-8">
              <span className="h-6 w-6 md:h-12 md:w-12 rounded-md bg-[#959595] bg-opacity-10 flex items-center justify-center pp-card-icon">
                <LinearSVG />
              </span>
              <div className="flex flex-col md:flex-row gap-3 items-center md:items-start text-xl md:text-3xl font-semibold md:font-bold">
                {countPostObj.all}
                <span className="text-sm text-gray-500 md:text-[20px] font-light text-center md:text-left">
                  Uploaded
                  <br />
                  Property
                </span>
              </div>
            </button>
            <button className="bg-primary hover:border-primary rounded-md flex flex-col md:flex-row gap-3 md:gap-6 items-center py-3 md:p-8 shadow-sm shadow-secondary">
              <span className="h-6 w-6 md:h-12 md:w-12 rounded-md bg-[#009FE3] bg-opacity-20 flex items-center justify-center">
                <LinearSVG />
              </span>
              <div className="flex flex-col md:flex-row gap-3 items-center md:items-start text-xl md:text-3xl font-semibold md:font-bold text-white">
                {countPostObj.occupied}
                <span className="text-sm text-white md:text-[20px] font-light text-center md:text-left">
                  Occupied
                  <br />
                  Property
                </span>
              </div>
            </button>
            <button className="border border-gray-300 hover:border-secondary rounded-md flex flex-col md:flex-row gap-3 md:gap-6 items-center py-3 md:p-8">
              <span className="h-6 w-6 md:h-12 md:w-12 rounded-md bg-[#959595] bg-opacity-10 flex items-center justify-center pp-card-icon">
                <LinearSVG />
              </span>
              <div className="flex flex-col md:flex-row gap-3 items-center md:items-start text-xl md:text-3xl font-semibold md:font-bold">
                {countPostObj.unOccupied}
                <span className="text-sm text-gray-500 md:text-[20px] font-light text-center md:text-left">
                  Unoccupied
                  <br />
                  Property
                </span>
              </div>
            </button>
          </div>
          
          <MyPropertyCardLoop propertyList={propertyList} />
        </div>
      )}
      
      <GenericModal modalState={confirmDialog || successDialog || errorDialog || copiedAlert}>
        {dialogLoader ? (
          <div className="flex justify-center items-center p-10 w-full">
            <PageLoader />
          </div>
        ) : (
          <div className="p-[54px] justify-center items-center text-center relative">
            <button
              onClick={closeAllDialog}
              className="py-[5px] px-3 rounded-full border border-black absolute top-3 right-3 hover:bg-gray-100"
            >
              X
            </button>
            
            <div className="flex flex-col gap-5 justify-center items-center mt-4">
              {dialogData?.svgComp}
              {dialogData?.title && (
                <h3 className="text-bold text-[20px] header-font">
                  {dialogData?.title}
                </h3>
              )}
              {dialogData?.subtitle && (
                <p className="font-light text-strong-[200] text-md mb-4">
                  {dialogData?.subtitle}
                </p>
              )}
            </div>
            
            {confirmDialog && (
              <div className="flex justify-center gap-4 mt-6">
                <button
                  type="button"
                  onClick={closeAllDialog}
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleDelete}
                  className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:w-auto sm:text-sm"
                >
                  Confirm
                </button>
              </div>
            )}
          </div>
        )}
      </GenericModal>
      
      <GenericModal modalState={shareDialog}>
        <div className="p-[25px] justify-center items-center text-center relative">
          <button
            onClick={closeAllDialog}
            className="py-[5px] px-3 rounded-full border border-black absolute top-3 right-3 hover:bg-gray-100"
          >
            X
          </button>
          
          <div className="flex flex-col gap-5 justify-center text-left mt-4">
            <h2 className="text-xl font-normal header-font">
              Share via
            </h2>
            <div className="mb-5">
              <SocialIcons />
            </div>
            <div className="flex items-center justify-between bg-gray-100 rounded-md p-2 w-full border border-stone-300">
              <p id="share-link" className="text-xs truncate mr-2">
                {"https://app.ruumies.site" +
                  location.pathname +
                  "?action=view&id=" +
                  workingSlug}
              </p>
              <button
                onClick={() => {
                  const link = "https://app.ruumies.site" + location.pathname + "?action=view&id=" + workingSlug;
                  if (copy(link, { debug: false, message: link })) {
                    toast.success("Link copied to clipboard!");
                  }
                }}
                className="text-secondary flex items-center gap-1 text-sm hover:text-primary transition-colors"
              >
                <IoCopyOutline />
                Copy
              </button>
            </div>
          </div>
        </div>
      </GenericModal>
    </>
  );
};

export default PropertyListScreen;